import React from 'react';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Typography,
    TextField,
    IconButton,
    Paper
} from '@material-ui/core';
import { Autocomplete, Alert } from '@material-ui/lab';

// import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AttachmentIcon from '@material-ui/icons/Attachment';

export function FileManager({ files, fileTypes, onFileUpload, onFileChange, onFileDelete }) {
    const onFileUploadClick = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = e => {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                const base64File = reader.result;
                if (file && base64File) {
                    onFileUpload({
                        name: file.name,
                        type: file.type,
                        data: base64File
                    });
                }
            };
            reader.readAsDataURL(file);
        };
        input.click();
    };
    return (
        <Card>
            <CardHeader title="Files" />
            <Divider />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Alert severity="warning">
                            Make sure that there is no customer personal information (name, surname, ID number, address,
                            phone number) in the file you send.
                        </Alert>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<AddAPhotoIcon />}
                            onClick={() => undefined}
                            disabled
                        >
                            Take Photo
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button fullWidth variant="outlined" startIcon={<AttachmentIcon />} onClick={onFileUploadClick}>
                            Upload File
                        </Button>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        {files.length > 0 ? (
                            <Grid container spacing={2}>
                                {files.map((file, index) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <Paper style={{ padding: '16px' }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Autocomplete
                                                        disabled={!!file.Id}
                                                        size="small"
                                                        fullWidth
                                                        value={fileTypes.find(ft => ft.Id === file.Type) || null}
                                                        options={fileTypes}
                                                        getOptionLabel={option => option.FieldText}
                                                        getOptionSelected={(option, value) => option.Id === value.Id}
                                                        renderInput={params => (
                                                            <TextField
                                                                {...params}
                                                                required
                                                                label="Select File Type"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                        onChange={(_event, newValue) => {
                                                            onFileChange({ ...file, Type: newValue.Id });
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    container
                                                    item
                                                    xs={12}
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                    direction="row"
                                                    wrap="nowrap"
                                                >
                                                    <Grid item>
                                                        <TextField
                                                            disabled={!!file.Id}
                                                            size="small"
                                                            fullWidth
                                                            variant="outlined"
                                                            label="File Name"
                                                            value={file.FileName}
                                                            onChange={e =>
                                                                onFileChange({
                                                                    ...file,
                                                                    FileName: e.target.value
                                                                })
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="body2" color="textSecondary">
                                                            {file.FileType}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item>
                                                        <Grid container item spacing={1} alignItems="center">
                                                            {/* <Grid item>
                                                                <IconButton size="small" onClick={() => undefined}>
                                                                    <CloudDownloadIcon />
                                                                </IconButton>
                                                            </Grid> */}
                                                            <Grid item>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => onFileDelete(file)}
                                                                >
                                                                    <DeleteForeverIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Typography variant="body2">No files uploaded yet.</Typography>
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

// function FileCard({ id, title, name, format, onDownload, onDelete }) {
//     return (
//         <Paper style={{ padding: '16px' }}>
//             <Grid container>
//                 <Grid item>
//                     <Typography variant="body2">{title}</Typography>
//                 </Grid>
//                 <Grid container item alignItems="center" justifyContent="space-between" direction="row" wrap="nowrap">
//                     <Grid item>
//                         <Typography variant="body1">{name}</Typography>
//                     </Grid>
//                     <Grid item>
//                         <Typography variant="body2" color="textSecondary">
//                             {format}
//                         </Typography>
//                     </Grid>

//                     <Grid item>
//                         <Grid container item spacing={1} alignItems="center">
//                             <Grid item>
//                                 <IconButton size="small" onClick={() => onDownload(id)}>
//                                     <CloudDownloadIcon />
//                                 </IconButton>
//                             </Grid>
//                             <Grid item>
//                                 <IconButton size="small" onClick={() => onDelete(id)}>
//                                     <DeleteForeverIcon />
//                                 </IconButton>
//                             </Grid>
//                         </Grid>
//                     </Grid>
//                 </Grid>
//             </Grid>
//         </Paper>
//     );
// }
